/* global frameName */

import {madnes_objects} from "../../../framework/src/engine/madnes/madnes_variables";
import {
    phaser_add_img,
    madnes_add_child,
    madnes_add_img,
    madnes_add_sprite,
    madnes_get_alpha,
    madnes_get_angle, madnes_get_dimension_he,
    madnes_get_dimension_wi, madnes_get_object_name,
    madnes_get_pos_x,
    madnes_get_pos_y,
    madnes_get_scale_x,
    madnes_get_scale_y, madnes_get_texture_he,
    madnes_get_texture_name, madnes_get_texture_wi, madnes_get_tint,
    madnes_get_visible, madnes_key_exist, madnes_kill_sprite,
    madnes_object_rename,
    madnes_remove_child,
    madnes_remove_children, madnes_remove_sprite, madnes_revive_sprite,
    madnes_set_alpha,
    madnes_set_angle,
    madnes_set_img_center,
    madnes_set_pos,
    madnes_set_pos_x,
    madnes_set_pos_y,
    madnes_set_scale,
    madnes_set_texture,
    madnes_set_visible, madnes_sprite_get_frame_name, madnes_sprite_set_frame, madnes_sprite_set_frame_name, madnes_tint
} from "../../../framework/src/engine/madnes/madnes_object";
import {madnes_add_mask} from "../../../framework/src/engine/madnes/madnes_draw";
import {
    madnes_add_bitmap_text,
    madnes_add_text, madnes_set_bitmap_float,
    madnes_set_text, madnes_set_text_bounds,
    madnes_set_text_shadow
} from "../../../framework/src/engine/madnes/madnes_text";
import {
    madnes_set_blend_mode,
    madnes_set_input_down,
    madnes_set_input_up,
    madnes_set_pivot
} from "../../../framework/src/engine/madnes/madnes";
import {randomString} from "../../utils/helpers";
import {MadnesAnims} from "./MadnesAnims";
import {main_phaser} from "../../../framework/src/engine/madnes/MadnesApp";

/**
 * @constructor
 * @param {?string=} name
 */
export function MadnesObject(name) {

    if(typeof name === 'undefined' || name == null) {
        name = this._generateId();
    }

    this.name = name;
    /** @type {MadnesAnims} */
    this.anims = null;

    /*if(obj) {
        madnes_objects[this.name] = obj;
    }*/
};

MadnesObject.prototype._generateId = function() {

    var key = randomString();
    while(MadnesObject.keyExists(key)) {
        key = randomString();
    }

    return key;
};

/**
 * @param {Object} obj
 * @returns {MadnesObject}
 */
MadnesObject.prototype._initObject = function(obj) {
    madnes_objects[this.name] = obj;
    return this;
};

/**
 * @param {string} name
 * @returns {MadnesObject}
 */
MadnesObject.prototype.setName = function(name) {

    if(madnes_object_rename(this.name, name)) {
        this.name = name;
    }

    return this;
};

/**
 * @returns {string}
 */
MadnesObject.prototype.getName = function() {
    return this.name;
};

/**
 * @public
 * @returns {MadnesAnims}
 */
MadnesObject.prototype.createAnims = function() {
    this.anims = new MadnesAnims().create(this);
    return this.anims;
};

/**
 * @param {string|null} texture
 * @param {number} x
 * @param {number} y
 * @returns {MadnesObject}
 */
MadnesObject.prototype.createSprite = function(texture, x, y) {
    madnes_add_sprite(this.name, texture, x, y);
    return this;
};

/**
 * @param {string|null} texture
 * @param {number} x
 * @param {number} y
 * @returns {MadnesObject}
 */
MadnesObject.prototype.createImg = function(texture, x, y) {
    madnes_add_img(this.name, texture, x, y);
    return this;
};

MadnesObject.prototype.addImg = function(texture, x, y, phaser = main_phaser) {
    phaser_add_img({name: this.name, key: texture, x, y, phaser});
    return this;
};

/**
 * @param {MadnesGraphics} madnesGraphics
 * @returns {MadnesObject}
 */
MadnesObject.prototype.addMask = function(madnesGraphics) {
    madnes_add_mask(this.name, madnesGraphics.name);
    return this;
};

/**
 * @param {string|number} text
 * @param {number} x
 * @param {number} y
 * @param {Object} style
 * @returns {MadnesObject}
 */
MadnesObject.prototype.createText = function(text, x, y, style) {
    madnes_add_text(this.name, x, y, text, style);
    return this;
};

/**
 * @param {string} key
 * @param {number} x
 * @param {number} y
 * @param {string|number} text
 * @param {number} size
 * @returns {MadnesObject}
 */
MadnesObject.prototype.createBitmapText = function(key, x, y, text, size) {
    madnes_add_bitmap_text(this.name, key, x, y, text, size);
    return this;
};

/**
 * @param {string|number|null} text
 * @param {boolean=} noformat
 * @returns {MadnesObject}
 */
MadnesObject.prototype.setText = function(text, noformat) {
    madnes_set_text(this.name, text, noformat);
    return this;
};

/**
 * @param {number=} x
 * @param {number=} y
 * @param {string=} color - 'rgba(0,0,0,1)'
 * @param {number=} blur
 * @param {boolean=} shadowStroke
 * @param {boolean=} shadowFill
 * @returns {MadnesObject}
 */
MadnesObject.prototype.setTextShadow = function(x, y, color, blur, shadowStroke, shadowFill) {
    madnes_set_text_shadow(this.name, x, y, color, blur, shadowStroke, shadowFill);
    return this;
};

MadnesObject.prototype.setTextBounds = function(x1, y1, x2, y2) {
    madnes_set_text_bounds(this.name, x1, y1, x2, y2);
    return this;
};

/**
 * @param {string|number} text
 * @param {number} maxWidth
 * @param {boolean=} noformat
 * @returns {MadnesObject}
 */
MadnesObject.prototype.setAdjustText = function(text, maxWidth, noformat) {
    madnes_set_bitmap_float(this.name, text, maxWidth, noformat);
    return this;
};


/**
 * @param {string|null=} texture
 * @returns {MadnesObject}
 */
MadnesObject.prototype.setTexture = function(texture) {
    madnes_set_texture(this.name, texture);
    return this;
};

/**
 * @returns {string}
 */
MadnesObject.prototype.getTextureName = function() {
    return madnes_get_texture_name(this.name);
};

/**
 * @param {number} idx
 * @returns {MadnesObject|undefined}
 */
MadnesObject.prototype.initChildByIdx = function(idx) {

    var child = madnes_objects[this.name].children[idx];

    if(!child) {
        return;
    }

    return new MadnesObject(this.name + "_ch_" + idx)._initObject(child);
};

/**
 * @returns {Array<MadnesObject>}
 */
MadnesObject.prototype.initChildren = function() {

    var children = [];
    for(var i = 0; i < madnes_objects[this.name].children.length; i++) {
        children.push(this.initChildByIdx(i));
    }

    return children;
};

/**
 * @param {MadnesObject} madnesObject
 * @returns {undefined}
 */
MadnesObject.prototype.removeChild = function(madnesObject) {

    madnes_remove_child(this.name, madnesObject.name);
    madnesObject.destroy();

};

MadnesObject.prototype.removeChilds = function() {
    madnes_remove_children(this.name);
};

/**
 * @param {MadnesObject} madnesObject
 * @returns {MadnesObject}
 */
MadnesObject.prototype.addChild = function(madnesObject) {
    madnes_add_child(this.name, madnesObject.name);
    return this;
};

/**
 * @param {number} alpha
 * @returns {MadnesObject}
 */
MadnesObject.prototype.setAlpha = function(alpha) {
    madnes_set_alpha(this.name, alpha);
    return this;
};

/**
 * @returns {number}
 */
MadnesObject.prototype.getAlpha = function() {
    return madnes_get_alpha(this.name);
};

/**
 * @param {boolean} bool
 * @returns {MadnesObject}
 */
MadnesObject.prototype.setVisible = function(bool) {
    madnes_set_visible(this.name, bool);
    return this;
};

/**
 * @returns {boolean}
 */
MadnesObject.prototype.getVisible = function() {
    return madnes_get_visible(this.name);
};

/**
 * @param {number} x
 * @param {number} y
 * @param {boolean=} keepVisibility - disable setting invisible of madnes_object when out of game bounds
 * @returns {MadnesObject}
 */
MadnesObject.prototype.setPos = function(x, y, keepVisibility) {
    madnes_set_pos(this.name, x, y, keepVisibility);
    return this;
};

/**
 * @param {number} x
 * @param {boolean=} keepVisibility
 * @returns {MadnesObject}
 */
MadnesObject.prototype.setPosX = function(x, keepVisibility) {
    madnes_set_pos_x(this.name, x, keepVisibility);
    return this;
};

/**
 * @param {number} y
 * @param {boolean=} keepVisibility
 * @returns {MadnesObject}
 */
MadnesObject.prototype.setPosY = function(y, keepVisibility) {
    madnes_set_pos_y(this.name, y, keepVisibility);
    return this;
};

/**
 * @param {number} x
 * @param {boolean=} keepVisibility
 * @returns {MadnesObject}
 */
MadnesObject.prototype.shiftPosX = function(x, keepVisibility) {
    madnes_set_pos_x(this.name, x + madnes_get_pos_x(this.name), keepVisibility);
    return this;
};

/**
 * @param {number} y
 * @param {boolean=} keepVisibility
 * @returns {MadnesObject}
 */
MadnesObject.prototype.shiftPosY = function(y, keepVisibility) {
    madnes_set_pos_y(this.name, y + madnes_get_pos_y(this.name), keepVisibility);
    return this;
};

/**
 * @returns {number}
 */
MadnesObject.prototype.getPosX = function() {
    return madnes_get_pos_x(this.name);
};

/**
 * @returns {number}
 */
MadnesObject.prototype.getPosY = function() {
    return madnes_get_pos_y(this.name);
};

/**
 * @param {string} mode NORMAL (0), ADD (1), MULTIPLY (2), SCREEN (3), OVERLAY (4), DARKEN (5), LIGHTEN (6), COLOR_DODGE (7),
 * COLOR_BURN (8), HARD_LIGHT (9), SOFT_LIGHT (10), DIFFERENCE (11), EXCLUSION (12), HUE (13), SATURATION (14), COLOR (15), LUMINOSITY(16)
 * @returns {MadnesObject}
 */
MadnesObject.prototype.setBlend = function(mode) {
    madnes_set_blend_mode(this.name, PIXI.blendModes[mode]);
    return this;
};

/**
 * @param {number} angle
 * @returns {MadnesObject}
 */
MadnesObject.prototype.setAngle = function(angle) {
    madnes_set_angle(this.name, angle);
    return this;
};

/**
 * @returns {number}
 */
MadnesObject.prototype.getAngle = function() {
    return madnes_get_angle(this.name);
};

/**
 * @public
 * @param {number} x
 * @param {number} y
 * @returns {MadnesObject}
 */
MadnesObject.prototype.setScale = function(x, y) {
    madnes_set_scale(this.name, x, y);
    return this;
};

/**
 * @public
 * @returns {Object}
 */
MadnesObject.prototype.getScale = function() {
    return { 'x': madnes_get_scale_x(this.name), 'y': madnes_get_scale_y(this.name) };
};

/**
 * @public
 * @returns {number}
 */
MadnesObject.prototype.getScaleX = function() {
    return madnes_get_scale_x(this.name);
};

/**
 * @public
 * @returns {number}
 */
MadnesObject.prototype.getScaleY = function() {
    return madnes_get_scale_y(this.name);
};

/**
 * @param {number} x
 * @param {number} y
 * @returns {MadnesObject}
 */
MadnesObject.prototype.setAnchor = function(x, y) {
    madnes_set_img_center(this.name, x, y);
    return this;
};

/**
 * @param {number} x
 * @param {number} y
 * @returns {MadnesObject}
 */
MadnesObject.prototype.setPivot = function(x, y) {
    madnes_set_pivot(this.name, x, y);
    return this;
};

/**
 * @returns {number}
 */
MadnesObject.prototype.getWidth = function() {
    return madnes_get_dimension_wi(this.name);
};

/**
 * @returns {number}
 */
MadnesObject.prototype.getTextureWidth = function() {
    return madnes_get_texture_wi(this.name);
};

/**
 * @returns {number}
 */
MadnesObject.prototype.getHeight = function() {
    return madnes_get_dimension_he(this.name);
};

/**
 * @returns {number}
 */
MadnesObject.prototype.getTextureHeight = function() {
    return madnes_get_texture_he(this.name);
};

/**
 * @param {number} frame
 * @returns {MadnesObject}
 */
MadnesObject.prototype.setFrame = function(frame) {
    madnes_sprite_set_frame(this.name, frame);
    return this;
};

/**
 * @public
 * @param {string} frameName
 * @returns {MadnesObject}
 */
MadnesObject.prototype.setFrameName = function(frameName) {
    madnes_sprite_set_frame_name(this.name, frameName);
    return this;
};

/**
 * @public
 * @returns {MadnesObject}
 */
MadnesObject.prototype.getFrameName = function() {
    return madnes_sprite_get_frame_name(this.name);
};

/**
 * @param {Function} func
 * @returns {MadnesObject}
 */
MadnesObject.prototype.onInputUp = function(func) {
    madnes_set_input_up(this.name, func);
    return this;
};

/**
 * @param {Function} func
 * @returns {MadnesObject}
 */
MadnesObject.prototype.onInputDown = function(func) {
    madnes_set_input_down(this.name, func);
    return this;
};

/**
 * @param {number} color
 * @returns {MadnesObject}
 */
MadnesObject.prototype.setTint = function(color) {
    madnes_tint(this.name, color);
    return this;
};

/**
 * @returns {number}
 */
MadnesObject.prototype.getTint = function() {
    return madnes_get_tint(this.name);
};

/**
 * Destroys MadnesObject
 * @returns {undefined}
 */
MadnesObject.prototype.removeObject = function() {
    this.anims && this.anims.destroy();

    if(!this.isDestroyed()) {
        this.removeChilds();
        madnes_remove_sprite(this.name);
    }

    this.name = null;
    this.anims = null;
};

MadnesObject.prototype.destroy = function() {
    this.removeObject();
};

/**
 * @returns {boolean}
 */
MadnesObject.prototype.isDestroyed = function() {
    return !madnes_key_exist(this.name);
};

MadnesObject.prototype.kill = function() {
    madnes_kill_sprite(this.name);
};

MadnesObject.prototype.revive = function() {
    madnes_revive_sprite(this.name);
};

/**
 * @returns {string|undefined}
 */
MadnesObject.prototype.getObjectName = function() {
    return madnes_get_object_name(this.name);
};


MadnesObject.prototype.$debug = function() {
    console.log(madnes_objects[this.name]);
};

/**
 * @param {MadnesObject|string} key
 * @returns {boolean}
 */
MadnesObject.keyExists = function(key) {
    return madnes_key_exist(typeof key === "string" ? key : key.name);
};